// Petals-linked sessions are rechecked against the organization's entitlement (server side). When
// the API answers `reauth_required` (419 on any request, 401 on refresh), the app signs in through
// Petals again: seamless while the Petals session lasts, the Petals sign-in page otherwise.
// Pure (no imports): app/test/unit/sso-reauth.test.mjs runs it under plain node.

/** True for an API answer that asks for a new Petals sign-in. */
export const needsReauth = (status, body) =>
    (status === 419 || status === 401) && body !== null && typeof body === 'object' &&
    body.error === 'reauth_required';

/**
 * A fetch that calls onReauth (once) when an API response under apiBase asks for it. The
 * response is returned unchanged either way (its body is read from a clone).
 */
export const withReauth = (fetchImpl, apiBase, onReauth) => {
    let started = false;
    return async (input, init) => {
        const res = await fetchImpl(input, init);
        if (started || (res.status !== 419 && res.status !== 401)) return res;
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (!apiBase || url.indexOf(apiBase) !== 0) return res;
        let body = null;
        try {
            body = await res.clone().json();
        } catch (e) { /* not JSON */ }
        if (needsReauth(res.status, body)) {
            started = true;
            onReauth();
        }
        return res;
    };
};
